const BreadcrumbList = ({ pages }) => {
  return `{
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
      ${pages.map(({ name, url }, i) => {
        return `
            {
              "@type": "ListItem",
              "position": ${i + 1},
              "item": {
                "@id": "${url}",
                "name": "${name}"
              }
            }
            `;
      })}
      ]
    }`;
};

export default BreadcrumbList;
